import { ArrowRightIcon } from "@heroicons/react/solid";
import LoadingButton from "@mui/lab/LoadingButton";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import dayjs from "dayjs";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import html2canvas from "html2canvas";
import check from "../../asset/check.png";
import upload from "../../asset/upload.png";
import "../../styles/logo.css";
import { Header } from "../header";
import Modal from "@mui/material/Modal";
import { useProfileStore, useLoginStore } from "../helpers/state";
import { FormControl, Select, MenuItem } from "@mui/material";
import {
  validateFile,
  shortenFilename,
  validationConfigs,
} from "../helpers/fileValidation";

export function PembaharuanKad() {
  const { login } = useLoginStore();
  const { profile } = useProfileStore();
  var CryptoJS = require("crypto-js");
  const [tauliah, setTauliah] = useState("Muat naik");
  const [mhpk, setMhpk] = useState("Muat naik");
  const [spih, setSpih] = useState("Muat naik");
  const navigate = useNavigate();
  const [sendLoader, setSendLoader] = useState(false);

  const [endDate, setEndDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [spihYear, setSpihYear] = useState(null);
  const [mhpkYear, setMhpkYear] = useState(null);
  const [Htauliah, setHtauliah] = useState("hidden");
  const [Hmhpk, setHMhpk] = useState("hidden");
  const [Hspih, setHSpih] = useState("hidden");
  const [fileTauliah, setFileTauliah] = useState(null);
  const [fileMhpk, setFileMhpk] = useState(null);
  const [fileSpih, setFileSpih] = useState(null);

  const [ITauliah, setITauliah] = useState(upload);
  const [IMhpk, setIMhpk] = useState(upload);
  const [ISpih, setISpih] = useState(upload);

  const bytes = CryptoJS.AES.decrypt(
    login.jwtToken,
    `${process.env.SECRET_KEY}`
  );
  var userToken = bytes.toString(CryptoJS.enc.Utf8);
  const pektaID = login.pektaID;
  // Using utility functions from fileValidation.js

  const adjustDates = (start, end) => {
    const finalStart = new Date(start);
    const finalEnd = new Date(end);
    finalStart.setDate(finalStart.getDate() + 1);
    finalEnd.setDate(finalEnd.getDate() + 1);
    return { finalStart, finalEnd };
  };

  const createAppData = (additionalData) =>
    JSON.stringify({
      data: {
        status: "pending",
        ...additionalData,
      },
    });

  const handleUpload = () => {
    const missingFields = [];
    if (!negeri) missingFields.push("Negeri");
    if (!startDate) missingFields.push("Tarikh Mula");
    if (!endDate) missingFields.push("Tarikh Akhir");
    if (!fileTauliah) missingFields.push("Fail Tauliah Mengajar");
    if (fileSpih && !spihYear) missingFields.push("Tahun SPIH/EPIH");
    if (fileMhpk && !mhpkYear)
      missingFields.push(
        "Tahun Rekod Kehadiran Muzakarah Haji Peringkat Kebangsaan (MHPK)"
      );

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Maklumat wajib belum lengkap",
        html: `<div class="text-left">Sila isi/muat naik medan berikut:<ul class="list-disc ml-5 mt-2">${missingFields
          .map((f) => `<li>${f}</li>`)
          .join("")}</ul></div>`,
      });
      return;
    }

    const todayDate = dayjs(new Date());
    const expDate = dayjs(endDate);
    if (expDate.isBefore(todayDate)) {
      Swal.fire({
        icon: "warning",
        title: "Tauliah Tamat Tempoh",
        text: "Tauliah Mengajar Negeri telah tamat tempoh",
      });
      return;
    }

    // Validate Negeri
    if (!negeri) {
      Swal.fire("Sila pilih negeri untuk Tauliah Mengajar Agama Islam Negeri.");
      return;
    }

    // Validate Negeri
    if (!negeri) {
      Swal.fire("Sila pilih negeri untuk Tauliah Mengajar Agama Islam Negeri.");
      return;
    }

    setSendLoader(true);

    const formData = new FormData();
    formData.append("files", fileTauliah);
    if (fileSpih) formData.append("files", fileSpih);
    if (fileMhpk) formData.append("files", fileMhpk);

    axios
      .post(`${process.env.REACT_APP_API_URL}/api/upload/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          console.log(percentCompleted);
        },
      })
      .then((response) => {
        const { finalStart, finalEnd } = adjustDates(startDate, endDate);
        let appData;
        const tauliahID = response.data[0].id;

        if (fileSpih && fileMhpk) {
          const spihID = response.data[1].id;
          const mhpkID = response.data[2].id;
          appData = createAppData({
            file_kutahu_cert: spihID,
            file_tafaqquh_haji_cert: tauliahID,
            file_mhpk_cert: mhpkID,
            qualification_start_date: finalStart,
            qualification_end_date: finalEnd,
            mhpk_year: mhpkYear,
            spih_year: spihYear,
            pekta: pektaID,
            tauliah_negeri: negeri,
          });
        } else if (!fileSpih && fileMhpk) {
          const mhpkID = response.data[1].id;
          appData = createAppData({
            file_tafaqquh_haji_cert: tauliahID,
            file_mhpk_cert: mhpkID,
            qualification_start_date: finalStart,
            qualification_end_date: finalEnd,
            mhpk_year: mhpkYear,
            pekta: pektaID,
            tauliah_negeri: negeri,
          });
        } else if (fileSpih && !fileMhpk) {
          const spihID = response.data[1].id;
          appData = createAppData({
            file_kutahu_cert: spihID,
            file_tafaqquh_haji_cert: tauliahID,
            qualification_start_date: finalStart,
            qualification_end_date: finalEnd,
            spih_year: spihYear,
            pekta: pektaID,
            tauliah_negeri: negeri,
          });
        } else {
          appData = createAppData({
            file_tafaqquh_haji_cert: tauliahID,
            qualification_start_date: finalStart,
            qualification_end_date: finalEnd,
            pekta: pektaID,
            tauliah_negeri: negeri,
          });
        }

        return axios.post(
          `${process.env.REACT_APP_API_URL}/api/katam-applications`,
          appData,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
              "Content-Type": "application/json",
            },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              console.log(percentCompleted);
            },
          }
        );
      })
      .then((response) => {
        setSendLoader(false);
        toast.success(
          "Permohonan berjaya, sila tunggu pengesahan daripada Bahagian Bimbingan Haji",
          {
            position: toast.POSITION.TOP_CENTER,
          }
        );
        console.log("application submitted successfully");

        const formattedDate = dayjs(
          response.data.data.attributes.createdAt
        ).format("DD/MM/YYYY");

        Swal.fire({
          icon: "success",
          title: "Permohonan KATAM Berjaya",
          html: `ID Permohonan: ${response.data.data.id}<br>
               Name pemohon: ${profile.full_name}<br>
               Emel pemohon: ${login.email}<br>
               Tarikh permohonan: ${formattedDate}`,
          footer: `
            Resit permohonan ini akan dimuat turun secara automatik untuk bukti permohonan KATAM.<br>
            Sila tangkap layar dan simpan untuk bukti Permohonan KATAM.
          `,
          confirmButtonText: "Ok",
          customClass: {
            footer: "SwalFooter",
          },
          didOpen: () => {
            const popup = Swal.getPopup();
            if (!popup) return;
            setTimeout(() => {
              // Clone the live popup into an off-screen, static container
              const clone = popup.cloneNode(true);
              // Reset positioning/layout so html2canvas gets a stable box
              clone.style.position = "static";
              clone.style.transform = "none";
              clone.style.margin = "0 auto";
              clone.style.boxShadow = "none";
              const liveWidth = popup.offsetWidth || 520;
              clone.style.maxWidth = `${liveWidth}px`;
              clone.style.width = `${liveWidth}px`;
              clone.style.padding = "20px 20px 16px 20px";

              const wrapper = document.createElement("div");
              wrapper.style.position = "fixed";
              wrapper.style.left = "-9999px";
              wrapper.style.top = "0";
              wrapper.style.width = `${liveWidth}px`;
              wrapper.appendChild(clone);
              document.body.appendChild(wrapper);

              // Freeze success icon animation and normalize text/button layout in the clone
              const style = document.createElement("style");
              style.innerHTML = `
                .swal2-icon.swal2-success .swal2-success-ring,
                .swal2-icon.swal2-success [class^="swal2-success-line"],
                .swal2-icon.swal2-success .swal2-success-fix { animation: none !important; transition: none !important; }
                .swal2-popup { box-sizing: border-box !important; background: #fff !important; }
                .swal2-title { margin: 8px 0 14px 0 !important; line-height: 1.35 !important; font-weight: 600 !important; text-align: center !important; }
                .swal2-html-container { margin: 0 0 30px 0 !important; line-height: 1.5 !important; word-break: break-word !important; white-space: normal !important; text-align: center !important; }
              `;
              clone.prepend(style);
              
              // Hide button and footer in the clone before capturing
              const actionsContainer = clone.querySelector('.swal2-actions');
              if (actionsContainer) {
                actionsContainer.style.display = 'none';
              }
              // Also hide the button directly by its classes
              const confirmBtn = clone.querySelector('.swal2-confirm') || clone.querySelector('.katam-receipt-confirm');
              if (confirmBtn) {
                confirmBtn.style.display = 'none';
              }
              const footer = clone.querySelector('.swal2-footer');
              if (footer) {
                footer.style.display = 'none';
              }

              html2canvas(clone, {
                scale: 2,
                useCORS: true,
                scrollX: 0,
                scrollY: 0,
                onclone: (clonedDoc) => {
                  // Hide the button and footer in the screenshot (keep them in live modal)
                  const actionsContainer = clonedDoc.querySelector('.swal2-actions');
                  if (actionsContainer) {
                    actionsContainer.style.display = 'none';
                  }
                  // Also hide the button directly by its classes
                  const confirmBtn = clonedDoc.querySelector('.swal2-confirm') || clonedDoc.querySelector('.katam-receipt-confirm');
                  if (confirmBtn) {
                    confirmBtn.style.display = 'none';
                  }
                  const footer = clonedDoc.querySelector('.swal2-footer');
                  if (footer) {
                    footer.style.display = 'none';
                  }
                },
              })
                .then((canvas) => {
                  canvas.toBlob((blob) => {
                    if (!blob) return;
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `Resit_Permohonan_KATAM-${response.data.data.id}.png`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);
                  });
                })
                .catch(() => {
                  // Ignore capture errors; user can still screenshot manually
                })
                .finally(() => {
                  document.body.removeChild(wrapper);
                });
            }, 1000);
          },
        }).then(() => {
          navigate("/myprofile");
        });
      })
      .catch((error) => {
        setSendLoader(false);
        const apiMsg =
          error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          error?.message ||
          "Permohonan tidak berjaya, sila cuba lagi.";
        Swal.fire({
          icon: "error",
          title: "Ralat Permohonan",
          text: `${apiMsg}`,
        });
        console.log("An error occurred:", error);
      });
  };

  // Malaysian states list
  const negeriList = [
    "Johor",
    "Kedah",
    "Kelantan",
    "Melaka",
    "Negeri Sembilan",
    "Pahang",
    "Perak",
    "Perlis",
    "Pulau Pinang",
    "Sabah",
    "Sarawak",
    "Selangor",
    "Terengganu",
    "Wilayah Persekutuan Kuala Lumpur",
    "Wilayah Persekutuan Labuan",
    "Wilayah Persekutuan Putrajaya",
  ];
  const [negeri, setNegeri] = useState("");

  return (
    <>
      <Header />
      <div className="bg-gray-50 h-screen pb-5">
        <main className="flex flex-col">
          <div className="ml-28 mt-8 mb-4">
            <button
              className="text-gray-500 font-medium"
              onClick={() => navigate("/myprofile")}
            >
              🡨 Kembali ke Profil
            </button>
          </div>
          {/*  <div className="bg-white rounded-md lg:mx-24 sm:mx-36 m-2"> */}
          <div className="bg-white rounded-md mx-4 md:mx-12 lg:mx-24">
            <div className="mx-4 pt-6 pb-20">
              <p className="text-4xl mb-2">Pembaharuan Kad Tauliah</p>
              <label>
                Dokumen dengan <b className="text-red-500">*</b> wajib di isi
                dengan lengkap
              </label>
              {/*First input*/}
              <div className="border-2 flex flex-col md:flex-row p-3 gap-4">
                {/* Status Icon */}
                <div className="bg-white border-2 rounded-md border-grey-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mb-2 sm:mr-2 sm:mt-0 sm:mb-0">
                  <svg
                    className={`w-3 h-3 text-green-600 pointer-events-none fill-current ${
                      fileTauliah && startDate && endDate && negeri
                        ? ""
                        : "hidden"
                    }`}
                    version="1.1"
                    viewBox="0 0 17 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="none" fillRule="evenodd">
                      <g
                        transform="translate(-9 -11)"
                        fill="#52912C"
                        fillRule="nonzero"
                      >
                        <path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
                      </g>
                    </g>
                  </svg>
                </div>

                <div className="flex flex-col lg:flex-row justify-between w-full">
                  {/* Label */}
                  <label className="mr-auto mb-2 text-sm lg:mb-0">
                    Tauliah Mengajar Agama Islam Negeri{" "}
                    <b className="text-red-500">*</b>
                  </label>

                  {/* Negeri Dropdown */}
                  <div className="mr-4 mb-2 lg:mb-0">
                    <FormControl sx={{ minWidth: 160 }}>
                      <Select
                        size="small"
                        displayEmpty
                        value={negeri}
                        onChange={(e) => setNegeri(e.target.value)}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <span style={{ color: "#666" }}>
                                Pilih Negeri
                              </span>
                            );
                          }
                          return selected;
                        }}
                      >
                        <MenuItem value="">Pilih Negeri</MenuItem>
                        {negeriList.map((n) => (
                          <MenuItem key={n} value={n}>
                            {n}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  {/* Dropdown */}
                  <DatePicker
                    label={"Tarikh Mula"}
                    sx={{
                      input: { "&::placeholder": { opacity: 1 } },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#E5E7EB",
                      },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px",
                      },
                      label: { color: "black" },
                      border: { borderColor: "#E5E7EB" },
                    }}
                    slotProps={{
                      textField: { placeholder: "Tarikh Mula", size: "small" },
                    }}
                    className="MyDatePicker w-full md:w-40"
                    format="DD-MM-YYYY"
                    onChange={(e) => {
                      setStartDate(e.$d);
                    }}
                    views={["year", "month", "day"]}
                  />
                  <div className="lg:mt-0 ml-0 mt-2 lg:ml-4 ">
                    <DatePicker
                      label={"Tarikh Akhir"}
                      sx={{
                        input: { "&::placeholder": { opacity: 1 } },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#E5E7EB",
                        },
                        ".MuiOutlinedInput-notchedOutline": {
                          borderRadius: "8px",
                        },
                        label: { color: "black" },
                        border: { borderColor: "#E5E7EB" },
                      }}
                      slotProps={{
                        textField: {
                          placeholder: "Tarikh Mula",
                          size: "small",
                        },
                      }}
                      className="MyDatePicker w-full md:w-40"
                      format="DD-MM-YYYY"
                      value={endDate}
                      onChange={(e) => {
                        setEndDate(e);
                      }}
                      views={["year", "month", "day"]}
                    />
                  </div>
                  {/* File Upload */}
                  <div className="mt-3 lg:mt-0 lg:ml-5 h-10 w-32 rounded-md cursor-pointer">
                    <label className="w-32 h-10 border-2 pl-3 rounded-lg cursor-pointer flex items-center ">
                      <img
                        className="h-4 w-4 float-left mt-1 mr-2 bg-fixed"
                        src={ITauliah}
                        alt="icon"
                      />
                      {tauliah}
                      <input
                        id="tauliah"
                        className="border-2 hidden "
                        accept="image/*,application/pdf"
                        type={"file"}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const validation = validateFile(
                              file,
                              validationConfigs.default
                            );
                            if (!validation.valid) {
                              Swal.fire({
                                icon: "error",
                                title: "Jenis Fail Tidak Sah",
                                text: validation.message,
                              });
                              e.target.value = ""; // Clear the input
                              return;
                            }

                            setTauliah(
                              shortenFilename(
                                e.target.value
                                  .toString()
                                  .split(/(\\|\/)/g)
                                  .pop()
                              )
                            );
                            setHtauliah("");
                            setITauliah(check);
                            setFileTauliah(file);
                          }
                        }}
                      />
                    </label>
                  </div>
                </div>
              </div>

              {/*Second input*/}
              <div className="border-2 flex flex-col sm:flex-row p-3 border-t-0">
                {/* Status Icon */}
                <div className="bg-white border-2 rounded-md border-grey-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mb-2 sm:mr-2 sm:mt-0 sm:mb-0">
                  <svg
                    className={`fill-current ${Hmhpk} w-3 h-3 text-green-600 pointer-events-none`}
                    version="1.1"
                    viewBox="0 0 17 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="none" fillRule="evenodd">
                      <g
                        transform="translate(-9 -11)"
                        fill="#52912C"
                        fillRule="nonzero"
                      >
                        <path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="flex flex-col sm:flex-row justify-between w-full">
                  <label className="mr-auto mb-2 text-sm sm:mb-0">
                    Rekod Kehadiran Muzakarah Haji Peringkat Kebangsaan (MHPK)
                  </label>
                  <DatePicker
                    label="Tahun"
                    sx={{
                      input: { "&::placeholder": { opacity: 1 } },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#E5E7EB",
                      },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px",
                      },
                      label: { color: "black" },
                      border: { borderColor: "#E5E7EB" },
                    }}
                    slotProps={{
                      textField: { placeholder: "Tahun", size: "small" },
                    }}
                    className="MyDatePicker w-40"
                    views={["year"]}
                    onChange={(e) => {
                      setMhpkYear(dayjs(e.$d).format("YYYY"));
                    }}
                  />
                  <div className="mt-3 sm:mt-0 ml-0 sm:ml-5 h-10 w-32 rounded-md cursor-pointer">
                    <label className="w-32 h-10 border-2 pl-3 rounded-lg cursor-pointer flex items-center ">
                      <img
                        className="h-4 w-4 float-left mt-1 mr-2 bg-fixed"
                        src={IMhpk}
                        alt="icon"
                      />
                      {mhpk}
                      <input
                        id="mhpk"
                        className="border-2 hidden overflow-hidden"
                        accept="image/*,application/pdf"
                        type={"file"}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const validation = validateFile(
                              file,
                              validationConfigs.default
                            );
                            if (!validation.valid) {
                              Swal.fire({
                                icon: "error",
                                title: "Jenis Fail Tidak Sah",
                                text: validation.message,
                              });
                              e.target.value = ""; // Clear the input
                              return;
                            }

                            setMhpk(
                              shortenFilename(
                                e.target.value
                                  .toString()
                                  .split(/(\\|\/)/g)
                                  .pop()
                              )
                            );
                            setHMhpk("");
                            setIMhpk(check);
                            setFileMhpk(file);
                          }
                        }}
                      />
                    </label>
                  </div>
                </div>
              </div>
              {/*Third input*/}
              <div className="border-2 flex flex-col sm:flex-row p-3 border-t-0">
                {/* Status Icon */}
                <div className="bg-white border-2 rounded-md border-grey-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mb-2 sm:mr-2 sm:mt-0 sm:mb-0">
                  <svg
                    className={`fill-current ${Hspih} w-3 h-3 text-green-600 pointer-events-none`}
                    version="1.1"
                    viewBox="0 0 17 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="none" fillRule="evenodd">
                      <g
                        transform="translate(-9 -11)"
                        fill="#52912C"
                        fillRule="nonzero"
                      >
                        <path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
                      </g>
                    </g>
                  </svg>
                </div>

                <div className="flex flex-col sm:flex-row justify-between w-full">
                  {/* Label */}
                  <label className="mr-auto mb-2 text-sm sm:mb-0">
                    Sijil Pembimbing Ibadat Haji (SPIH) / Program Eksekutif
                    Pembimbing Ibadat Haji (EPIH)
                  </label>

                  <DatePicker
                    label="Tahun"
                    sx={{
                      input: { "&::placeholder": { opacity: 1 } },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#E5E7EB",
                      },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px",
                      },
                      label: { color: "black" },
                      border: { borderColor: "#E5E7EB" },
                    }}
                    slotProps={{
                      textField: { placeholder: "Tahun", size: "small" },
                    }}
                    className="MyDatePicker w-40"
                    views={["year"]}
                    onChange={(e) => {
                      setSpihYear(dayjs(e.$d).format("YYYY"));
                    }}
                    onError={(error) => {
                      console.log(error);
                    }}
                  />
                  {/* Dropdown */}

                  {/* File Upload */}
                  <div className="mt-3 sm:mt-0 sm:ml-5 h-10 w-32  rounded-md cursor-pointer">
                    <label className="w-32 h-10 border-2 pl-3 rounded-lg cursor-pointer flex items-center ">
                      <img
                        className="h-4 w-4 float-left mt-1 mr-2 bg-fixed"
                        src={ISpih}
                        alt="icon"
                      />
                      {spih}
                      <input
                        id="spih"
                        className="border-2 hidden"
                        accept="image/*,application/pdf"
                        type={"file"}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const validation = validateFile(
                              file,
                              validationConfigs.default
                            );
                            if (!validation.valid) {
                              Swal.fire({
                                icon: "error",
                                title: "Jenis Fail Tidak Sah",
                                text: validation.message,
                              });
                              e.target.value = ""; // Clear the input
                              return;
                            }

                            setSpih(
                              shortenFilename(
                                e.target.value
                                  .toString()
                                  .split(/(\\|\/)/g)
                                  .pop()
                              )
                            );
                            setHSpih("");
                            setISpih(check);
                            setFileSpih(file);
                          }
                        }}
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center mb-8">
              <LoadingButton
                onClick={handleUpload}
                loading={sendLoader}
                loadingPosition="end"
                variant="contained"
                color="success"
                sx={{ borderRadius: "5px", margin: "7px" }}
                size="medium"
                endIcon={<ArrowRightIcon className="h-5 w-5 " />}
              >
                Hantar
              </LoadingButton>
            </div>
          </div>
        </main>
      </div>
      <Modal
        className=""
        open={sendLoader}
        onClose={() => console.log("close")}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="flex justify-center items-center h-screen"></div>
      </Modal>
    </>
  );
}
